import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export const Success = () => {

    let navigate = useNavigate();

    const redirectToDashboard = () => {
        navigate('/dashboard');
    }

    return (
        <Modal
            className=''
            show={true}
            backdrop="static"
            keyboard={false}
            centered>
            <Modal.Header>
                <div className='pageTitle'>
                    <span>Payment Success</span>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p>Thank you for your purchase! Your tariff plan has been successfully activated.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className='btn mainBtn acceptBtn'
                    onClick={() => redirectToDashboard()}>Ok</button>
            </Modal.Footer>
        </Modal>
    )
};